import * as ActionTypes from '../constants/ActionTypes';

// ----------------------
// Action Creators
// ----------------------

export function setMessage(messageStatus, message) {
  return {
    type: ActionTypes.SET_MESSAGE,
    messageStatus: messageStatus,
    message: message,
  }
}



// WEBPACK FOOTER //
// ./src/actions/systemMessage.js